export default (cityObj) => {
  if (!cityObj) return

  const { name_with_region, country_name } = cityObj

  return `${`${country_name},` || ''} ${`${name_with_region}` || ''}`
}
